import React from "react";
import "~/less/web-internal.less";
import { cls } from "cls";
import { withUserAndChat } from "~/common/Store/connectUserAndChat";
import { User } from "~/common/Store/models/User";
import { useInternalNotes } from "./hooks/useInternalNotes";
interface InternalNotesButtonProps {
  categoryId: number;
  user: User;
}
export const defaultInternalNotesData = {
  categoryId: 0,
  link: ""
};
const InternalNotesButton = ({
  categoryId,
  user
}: InternalNotesButtonProps) => {
  const isInternal = user.analyticsData?.is_on_vpn?.toLocaleUpperCase() === "YES";
  const internalNotesData = useInternalNotes(categoryId, isInternal);
  return internalNotesData.categoryId && internalNotesData.link ? <a type="button" href={internalNotesData.link} target="_blank" rel="noopener noreferrer" id="web-internal-trigger" className={cls("webinfo-trigger", "webinfo-trigger--attention", "webinfo-trigger--expanded")} data-testid="show-internal-notes-button" data-sentry-component="InternalNotesButton" data-sentry-source-file="InternalNotesButton.tsx">
      <i className="icon-attention" />
      <span className="webinfo-trigger__text">Category Internal Notes</span>
    </a> : null;
};
export default withUserAndChat(InternalNotesButton);